import React, { Component } from "react";
import { DayPilot, DayPilotCalendar } from "@daypilot/daypilot-lite-react";
import axios from "axios";

class Calendar extends Component {
  state = { resource_id: -1 };
  constructor(props) {
    super(props);
    this.state = {
      viewType: "Week",
      onEventClick: async (args) => {
        const dp = this.calendar;
        const modal = await DayPilot.Modal.prompt(args.e.text());
        if (!modal.result) {
          return;
        }
        const e = args.e;
        e.data.text = modal.result;
        dp.events.update(e);
      },
    };
  }

  componentDidMount() {
    this.setState({
      startDate: "2022-02-22",
      endDate: "2022-02-29",
      events: [
        {
          id: 1,
          text: "Event 1 ojweo rjwioeq rjiowjeq riojqwoei riowqej riojqwoi rweqo rjwoeqij rioqwej roiweqoi rjwioeqj roiwjeq",
          start: "2022-02-22T07:00:00",
          end: "2022-02-22T13:00:00",
        },
        {
          id: 2,
          text: "Event 2",
          start: "2022-02-22T13:30:00",
          end: "2022-02-22T15:30:00",
          backColor: "#6aa84f",
        },
        {
          id: 3,
          text: "Event 3",
          start: "2022-02-23T13:30:00",
          end: "2022-02-23T15:30:00",
          backColor: "#6aa84f",
        },
      ],
    });
    //this.getTrainer();
  }

  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  async getTrainer() {
    //console.log(this.props.firstname);
    //const { firstname, lastname } = this.state;
    var link =
      "http://localhost/php/coursecal/searchResources.php?firstname=" +
      this.props.firstname +
      "&lastname=" +
      this.props.lastname;
    const res = await axios.get(link);

    var data = res["data"];
    var currentWeek = this.getMonday(new Date());
    var todayDate = currentWeek.toISOString().slice(0, 10);
    //console.log(data);
    //console.log(currentWeek);
    var link2 =
      "http://localhost/php/coursecal/trainer.php?resource_id=" +
      data[0]["resource_id"] +
      "&start_date=" +
      todayDate;
    const resGetCCP = await axios.get(link2);
    var data2 = resGetCCP["data"];
    console.log(link2);
    console.log(data2);
    this.setState({ resource_id: data[0]["resource_id"] });
    //get resource timetable
    //http://localhost/php/coursecal/trainer.php?resource_id=3&start_date=22-02-22
  }

  render() {
    const { ...config } = this.state;
    return (
      <div>
        <DayPilotCalendar heightSpec="Full" widthSpec="Full" {...config} />
      </div>
    );
  }
}

export default Calendar;
